module.exports = __webpack_public_path__ + "static/media/IT26SAD.7d3d3b00.png";